import React from "react";
import { Alert, Button } from 'react-bootstrap'
import Collapse from 'react-bootstrap/Collapse'
import { quoteStepChanged } from "../../state/appActions";
import { updateVehicle, reloadVehicle } from "../../state/fullQuoteActions";
import { IQuoteStepState } from "../../components/interfaces";
import { IAppState } from "../../state/interfaces";
import { connect } from "react-redux";
import { PATHS, FULL_QUOTE_STEPS, COMPONENTS, QUOTE_QUESTIONS, YES_NO } from "../../AppConstants";
import { ValidatableForm } from "../../components/ValidatableForm"
import { ValidatableFormGroup } from "../../components/ValidatableFormGroup"
import { IVehicleStepProps } from "../../components/interfaces";
import Utilities from "../../classes/Utilities";
import { validationUtils } from "../../validation/Validation";
import { QuoteStep } from "./QuoteStepLayout";
import ButtonContinue from "../../components/ButtonContinue";
import QuoteStepBase from '../../components/QuoteStepBase'
import { IAddressChangeResult } from "../../classes/Domain";
import { IVehicle, IUpdateVehicleResult } from "../../classes/ExternalQuote";
import VehicleTitle from '../../components/VehicleTitle'
import BravoApiClient from "../../classes/BravoApiClient";
import Question from '../../components/Question'
import Address from "../../components/Address";
import * as _ from 'lodash';

interface IAppStateUpdate {
    quoteId: number,
    paymentPlanCode: number,
    updateLienholder: boolean,
    updateGaragingAddress: boolean,
    vehicle: IVehicle;
}

interface IVehicleUpdate {
    quoteRerated: boolean,
    vehicleChanged: boolean,
    quoteId: number,
    vehicleId: number;
}

interface IState extends IQuoteStepState {
    updateLienholder: boolean,
    updateGaragingAddress: boolean,
    invalidGaragingAddress: boolean,
    invalidLienholderAddress: boolean,
    salvageWarningWasDemonstrated: boolean,
    addressVerification: string,
    wasSalvaged: string,
    updateResult: IUpdateVehicleResult | null,
    vehicle: IVehicle | null,
    showSalvageWarning: boolean;
}

interface IProps extends IVehicleStepProps {
    quoteId: number,
    paymentPlanCode: number,
    vehiclesCount: number,
    currentVehicle: IVehicle,
    reloadVehicle: (update: IVehicleUpdate) => Promise<any>;
}

class Car extends QuoteStepBase<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.next = this.next.bind(this);
        this.onAddressChanged = this.onAddressChanged.bind(this);
        this.onLienholderAddressChanged = this.onLienholderAddressChanged.bind(this);
        this.onAddressVerificationChanged = this.onAddressVerificationChanged.bind(this);
        this.confirmSalvageWarning = this.confirmSalvageWarning.bind(this);
        this.onVinChanged = this.onVinChanged.bind(this);

        this.state = {
            vehicle: null,
            updateLienholder: false,
            updateGaragingAddress: false,
            addressVerification: YES_NO.YES,
            wasSalvaged: "",
            invalidGaragingAddress: false,
            invalidLienholderAddress: false,
            salvageWarningWasDemonstrated: false,
            updatingStore: false,
            errors: null,
            updateResult: null,
            showSalvageWarning: false
        };
    }

    componentDidMount() {
        this.props.reportCurrentStep();

        this.setState({ ...this.state, updatingStore: false, errors: null });

        validationUtils.subscribeToValidationFailure(FULL_QUOTE_STEPS.CARS,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, errors: validationData });
            });
    }

    componentWillUnmount() {
        validationUtils.unsubscribeFromValidationFailure(FULL_QUOTE_STEPS.CARS);
    }

    static getDerivedStateFromProps(nextProps: IProps, prevState: IState) {
        if (nextProps.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE) {
            const vehicle = { ...nextProps.currentVehicle };
            if (!vehicle.garagingAddress) {
                vehicle.garagingAddress = nextProps.currentVehicle.garagingAddress;
            }

            nextProps.meta.propsSource = "";

            return {
                ...prevState,
                wasSalvaged: "undefined" === typeof vehicle.wasSalvaged || null === vehicle.wasSalvaged  ? "" : vehicle.wasSalvaged ? YES_NO.YES : YES_NO.NO,
                vehicle: vehicle
            };
        }

        return prevState;
    }

    next(event: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        event.preventDefault();

        this.setState({ updatingStore: true }, () => {

            var nextUrl = this.props.vehicleIndex < this.props.vehiclesCount - 1
                ? Utilities.formatUrl(PATHS.FQ_CARS, (this.props.vehicleIndex + 1).toString())
                : Utilities.formatUrl(PATHS.FQ_DRIVERS, "")

            //const updatedVehicle = {
            //    ...this.props.currentVehicle,
            //    ...this.state.vehicle
            //};

            this.props.updateAppState({
                quoteId: this.props.quoteId,
                vehicle: this.state.vehicle,
                paymentPlanCode: this.props.paymentPlanCode,
                updateLienholder: this.state.updateLienholder,
                updateGaragingAddress: this.state.updateGaragingAddress
            })
                .then((response) => {
                    this.setState({ updateResult: response.data }, () => {
                        if (!this.state.updateResult?.isSuccess) {
                            this.setState({ ...this.state, updatingStore: false, errors: null });
                        }
                        else if (this.state.updateResult.vehicleChanged || this.state.updateResult.wasSalvaged) {
                            this.props.reloadVehicle({
                                quoteId: this.props.quoteId,
                                vehicleId: this.state.vehicle ? this.state.vehicle.id : 0,
                                vehicleChanged: true,
                                quoteRerated: this.state.updateResult.isRerated
                            })
                            .then(() => this.setState({ updatingStore: false, errors: null }, () => this.props.history.push(nextUrl)),
                                () => this.setState({ ...this.state, updatingStore: false })
                            );
                        }
                        else {
                            this.setState({ updatingStore: false, errors: null }, () => this.props.history.push(nextUrl));
                        }
                    });
                },
                    () => {
                        this.setState({ ...this.state, updatingStore: false });
                    });
        });
    }

    handleLienholderSearch(query) {
        const apiClient = new BravoApiClient();
        return apiClient.getLienholders(query).then((response) => response.data);
    }

    onLienholderChange(value: string, property: string) {
        this.setStateValue(true, "updateLienholder", this.state);
        if (this.state.vehicle) {
            this.setStateValue(value, property, this.state.vehicle.lienholder);
        }
    }

    onAddressVerificationChanged(v: string) {
        this.setState({
            ...this.state, addressVerification: v, invalidGaragingAddress: YES_NO.NO === v
        });
    }

    onVinChanged(v: string) {
        const { vehicle } = { ...this.state };
        const currentVehicle = vehicle;

        if (currentVehicle) {
            currentVehicle.vin = v;
        }

        this.setState({ ...this.state, vehicle: currentVehicle });
    }

    onSalvagedChanged(v: string) {
        const { vehicle } = { ...this.state };
        const currentVehicle = vehicle;

        let showSalvageWarning = false;

        //console.log(this.state.vehicle?.coverages);
        //console.log(_.filter(this.state.vehicle?.coverages, (c) => c.name === "COMP" || c.name === "COLL"));

        if (v === YES_NO.YES
            && !this.state.salvageWarningWasDemonstrated
            && 0 < _.filter(this.state.vehicle?.coverages, (c) => (c.name === "COMP" || c.name === "COLL") && c.limit).length) {
            showSalvageWarning = true;
        }

        if (currentVehicle) {
            currentVehicle.wasSalvaged = v === YES_NO.YES;
        }

        const updateLienholder = v === YES_NO.YES ? false : this.state.updateLienholder;
        this.setState({ ...this.state, wasSalvaged: v, showSalvageWarning, vehicle: currentVehicle, updateLienholder });
    }

    onAddressChanged(result: IAddressChangeResult) {
        const { vehicle } = { ...this.state };
        const currentState = vehicle;

        if (currentState) {
            currentState.garagingAddress = result.address;
        }

        //this.setState({ ...this.state, vehicle: currentState, updateGaragingAddress: true });
        this.setState({
            ...this.state, vehicle: currentState, updateGaragingAddress: true, invalidGaragingAddress: !(result.hasOwnProperty("isValid") && result.isValid)
        });
    }

    onLienholderAddressChanged(result: IAddressChangeResult) {
        const { vehicle } = { ...this.state };
        const currentState = vehicle;

        if (currentState && currentState.lienholder) {
            currentState.lienholder.address = result.address;
        }

        //this.setState({ ...this.state, vehicle: currentState, updateGaragingAddress: true });
        this.setState({
            ...this.state, vehicle: currentState, updateLienholder: true, invalidLienholderAddress: !(result.hasOwnProperty("isValid") && result.isValid)
        });
    }

    confirmSalvageWarning() {
        this.setState({ ...this.state, salvageWarningWasDemonstrated : true, showSalvageWarning : false });
    }

    render() {
        return (
            <QuoteStep id="car">
                <ValidatableForm hasErrors={null != this.state.errors}>
                    <div className="titleArea">
                        <VehicleTitle vehicle={this.props.currentVehicle} />
                    </div>

                    {
                        this.state.updateResult && !this.state.updateResult.isSuccess && this.state.updateResult.errors
                            ? <Alert variant={"danger"}>
                                <p><strong className="text-uppercase">Sorry! Can not process your quote!</strong></p>
                                <p>Please review errors below</p>
                                <ul>
                                    {
                                        this.state.updateResult.errors.map((error) => (
                                            <li key={Utilities.uniqueId()}>
                                                <p className="text-uppercase" dangerouslySetInnerHTML={{ __html: error }}></p>
                                            </li>
                                        ))
                                    }
                                </ul>
                            </Alert>
                            : null
                    }

                    <p className="info">We need to gather some final details about your vehicle to verify we have everything correct:</p>

                    <ValidatableFormGroup
                        label="VIN"
                        value={this.getValueSafe(this.state.vehicle, "vin")}
                        placeholder="VIN"
                        validated={null !== this.state.errors}
                        validationError={validationUtils.getValidationErrorFor(this.state.errors, "vin")}
                        onChange={(e) => { this.onVinChanged(e.target.value.toString().trim()) }} />

                    <Question
                        name="wasSalvaged"
                        selectedValue={this.state.wasSalvaged}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "wasSalvaged")}
                        selected={(v) => this.onSalvagedChanged(v)}
                        items={[YES_NO.YES, YES_NO.NO]}
                        lable="Has this vehicle ever been salvaged or declared a total loss?" />

                    <Collapse in={this.state.showSalvageWarning}>
                        <div>
                            <Alert variant={"warning"}>
                                <h5 className="text-center"><strong className="text-uppercase">Warning!</strong><br /> Salvaged vehicles are not eligible for comprehensive/collision</h5>
                                <p className="text-center">
                                    <Button
                                        size="sm"
                                        onClick={() => this.confirmSalvageWarning()}>
                                        OK
                                            </Button>
                                </p>
                            </Alert>
                        </div>
                    </Collapse>

                    {
                        this.state.vehicle?.hasLienholder && !this.state.vehicle.wasSalvaged
                            ?
                            <div>
                                <div className="titleArea">
                                    <h5>Lienholder</h5>
                                </div>

                                <ValidatableFormGroup
                                    label="Name"
                                    value={this.getValueSafe(this.state.vehicle.lienholder, "name")}
                                    placeholder="Name"
                                    validated={null !== this.state.errors}
                                    validationError={validationUtils.extractFirstErrorByPrefix(this.state.errors, "lienholder.", "name")}
                                    onChange={(e) => { this.onLienholderChange(e.target.value.toString(), "name") }} />

                                <Address
                                    errors={validationUtils.extractErrorsByPrefix(this.state.errors, "lienholder.address.")}
                                    fieldsVisibility={{ apartment: false }}
                                    value={this.state.vehicle?.lienholder ? this.state.vehicle.lienholder.address : null}
                                    onChange={this.onLienholderAddressChanged} />
                            </div>
                            : null
                    }

                    {
                        //<Form.Group style={{ display: this.state.vehicle && this.state.vehicle.isLeased ? '' : 'none' }}>
                        //    <Form.Label>Lienholder</Form.Label>
                        //    <Suggest
                        //        id="basic-behaviors-example"
                        //        minLength={2}
                        //        placeholder="Enter lienholder..."
                        //        onSearch={(q) => this.handleLienholderSearch(q)}
                        //        className={this.state.errors ? (validationUtils.hasValidationErrorFor(this.state.errors, "lienholder") ? "is-invalid" : "is-valid") : ""}
                        //        onChange={(selected) => this.onLienholderChange(selected)}
                        //        defaultSelected={this.state.vehicle?.lienholder ? [{ name: this.state.vehicle.lienholder.name }] : null}
                        //    />
                        //    {this.state.errors && validationUtils.hasValidationErrorFor(this.state.errors, "lienholder")
                        //        ? <Form.Control.Feedback type="invalid">
                        //            {validationUtils.getValidationErrorFor(this.state.errors, "lienholder")}
                        //        </Form.Control.Feedback>
                        //        : null
                        //    }
                        //</Form.Group>
                    }                    

                    <Question
                        name="addressVerification"
                        selectedValue={this.state.addressVerification}
                        error={validationUtils.getValidationErrorFor(this.state.errors, "addressVerification")}
                        selected={(v) => this.onAddressVerificationChanged(v)}
                        items={[YES_NO.YES, YES_NO.NO]}
                        lable="Is this the correct location where you keep your car?" />

                    <div className="info-disclosure address" style={{ display: YES_NO.YES === this.state.addressVerification ? '' : 'none' }}>
                        {this.props.currentVehicle.garagingAddress ? this.props.currentVehicle.garagingAddress.street : ""}{this.props.currentVehicle.garagingAddress && this.props.currentVehicle.garagingAddress.apartment ? ", " + this.props.currentVehicle.garagingAddress.apartment : ""}<br />
                        {this.props.currentVehicle.garagingAddress ? this.props.currentVehicle.garagingAddress.city : ""}, {this.props.currentVehicle.garagingAddress ? this.props.currentVehicle.garagingAddress.stateCode : ""} {this.props.currentVehicle.garagingAddress ? this.props.currentVehicle.garagingAddress.zipCode : ""}<br />
                    </div>

                    {
                        YES_NO.NO === this.state.addressVerification
                            ?
                            <Address label="Where do you keep your car?"
                                errors={validationUtils.extractErrorsByPrefix(this.state.errors, "garagingAddress.")}
                                value={this.state.vehicle ? this.state.vehicle.garagingAddress : null}
                                onChange={this.onAddressChanged} />
                            : null
                    }

                    <div className="btnContainer">
                        <ButtonContinue
                            disabled={this.state.updatingStore || this.state.invalidGaragingAddress || (this.state.vehicle?.hasLienholder && this.state.invalidLienholderAddress) || (this.state.showSalvageWarning && !this.state.salvageWarningWasDemonstrated)}
                            showLoading={this.state.updatingStore}
                            onClick={this.next} />
                    </div>
                </ValidatableForm>
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState, ownProps: IVehicleStepProps) => {
    var vehicleIndex = !ownProps.match.params["vehicleIndex"]
        ? 0
        : parseInt(ownProps.match.params["vehicleIndex"], 10);
    var vehicle = state.externalQuote?.vehicles[vehicleIndex];

    if (vehicle) {
        console.log("vehicle.hasLienholder=" + vehicle.hasLienholder);
        if (vehicle.hasLienholder && !vehicle.lienholder) {
            vehicle.lienholder = {
                name: "",
                address: null
            };
        }
    }

    return {
        vehicleIndex: vehicleIndex,
        quoteId: state.externalQuote?.rtrQuoteId,
        paymentPlanCode: state.externalQuote?.paymentPlanCode,
        vehiclesCount: state.externalQuote?.vehicles.length,
        currentVehicle: vehicle,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE }
    };
};

let mapDispatch = (dispatch: any) => {
    return {
        reportCurrentStep: () => dispatch(quoteStepChanged(FULL_QUOTE_STEPS.CARS)),
        updateAppState: (update: IAppStateUpdate) => dispatch(updateVehicle(update.quoteId, update.vehicle, update.paymentPlanCode, update.updateLienholder, update.updateGaragingAddress)),
        reloadVehicle: (update: IVehicleUpdate) => dispatch(reloadVehicle(update.quoteId, update.vehicleId, update.vehicleChanged, update.quoteRerated))
    };
};

export default connect(mapProps, mapDispatch)(Car);